import React from 'react';
import {Button,Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//Import Select Component
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import RenderHelper from './render.js'

export default {
  RegisterModal:function(self){
    return(
      <Modal
        isOpen={self.state.Register.modal}
        toggle={self.__ToogleRegisterModal__}
        className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleRegisterModal__}>{'Add new User'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div className="form-group">
            <label htmlFor="Username">Username</label>
            <input
              type="text"
              className="form-control"
              id="Username"
              placeholder="Enter Username"
              value = {self.state.Register.Username}
              onChange={(event)=> self.setState({Register:{...self.state.Register,Username:event.target.value} })}
            />
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Firstname">First Name</label>
              <input
                type="text"
                className="form-control"
                id="Firstname"
                placeholder="Enter First Name"
                value = {self.state.Register.FirstName}
                onChange={(event)=> self.setState({Register:{...self.state.Register,FirstName:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Lastname">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="Lastname"
                placeholder="Enter Last Name"
                value = {self.state.Register.LastName}
                onChange={(event)=> self.setState({Register:{...self.state.Register,LastName:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Email">Email</label>
              <input
                type="text"
                className="form-control"
                id="Email"
                placeholder="Enter Email"
                value = {self.state.Register.Email}
                onChange={(event)=> self.setState({Register:{...self.state.Register,Email:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Tag">Phone Number</label>
              <input
                type="text"
                className="form-control"
                id="Phone"
                placeholder="Enter Phone Number"
                value = {self.state.Register.Phone}
                onChange={(event)=> self.setState({Register:{...self.state.Register,Phone:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Address">Address</label>
              <div className="float-right">
                <button type="button" style={{ fontSize : 12 }} className="btn btn-sm btn-success" onClick={() => self.__ToogleMapModal__(1)}><i className="fa fa-dot-circle-o"></i> Select in Map</button>
              </div>
              <input
                type="text"
                className="form-control"
                id="Address"
                placeholder="Enter Address"
                value = {self.state.Register.Address}
                onChange={(event)=> self.setState({Register:{...self.state.Register,Address:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Address2">Address 2</label>
              <input
                type="text"
                className="form-control"
                id="Address2"
                placeholder="Enter Address"
                value = {self.state.Register.Address2}
                onChange={(event)=> self.setState({Register:{...self.state.Register,Address2:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                  <label htmlFor="City">City</label>
                  <Select
                    name="PurchaseVendorName"
                    placeholder="Type City"
                    id="City"
                    value={self.state.Register.CityAbbreviations}
                    options={RenderHelper.RenderMasterAutoComplete(self.props.CityReducer,true)}
                    onChange={(val)=>self.__HandleCityChanged__(val,self)}
                  />
              </div>
              <div className="col-md-6">
                <label htmlFor="Postal">Postal</label>
                <input
                  type="number"
                  className="form-control"
                  id="Postal"
                  placeholder="Enter Postal"
                  value = {self.state.Register.Postal}
                  onChange={(event)=> self.setState({Register:{...self.state.Register,Postal:event.target.value} })}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                  <label htmlFor="Tag">Tag</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Tag"
                    placeholder="Enter Tag"
                    value = {self.state.Register.Tag}
                    onChange={(event)=> self.setState({Register:{...self.state.Register,Tag:event.target.value} })}
                  />
              </div>
              <div className="col-md-6">
                <label htmlFor="Role">Role</label>
                <Select
                  name="PurchaseVendorName"
                  placeholder="Type Role"
                  id="Role"
                  value={self.state.Register.RoleAlias}
                  options={RenderHelper.RenderMasterAutoComplete(self.props.RoleReducer,true)}
                  onChange={(val)=>self.__HandleRoleChanged__(val,self)}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="Password">Password</label>
            <input
              type="password"
              className="form-control"
              id="Password"
              placeholder="Enter Password"
              value = {self.state.Register.Password}
              onChange={(event)=> self.setState({Register:{...self.state.Register,Password:event.target.value} })}
            />
          </div>
          <div className="row">
            <div className="form-group col-sm-12">
            </div>

          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleRegisterModal__}>Cancel</Button>
          <Button color="primary" onClick={()=>self.__Save__(self)}>Save</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
  DeleteModal:function(self){
    return(
      <Modal isOpen={self.state.Delete.modal} toggle={self.__ToogleDeleteModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleDeleteModal__}>{'Delete User'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div>
            {"Are you sure want to delete this user?"}
          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleDeleteModal__}>Cancel</Button>
          <Button color="danger" onClick={()=>self.__Delete__(self)}>Delete</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
  UpdateModal:function(self){
    return(
      <Modal isOpen={self.state.Update.modal} toggle={self.__ToogleUpdateModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleUpdateModal__}>{'Edit User'}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="Name">Username</label>
            <input
              type="text"
              className="form-control"
              id="Name"
              placeholder="Enter Username"
              value = {self.state.Update.Username}
              disabled
              onChange={(event)=> self.setState({Update:{...self.state.Update,Username:event.target.value} })}
            />
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Name">First Name</label>
              <input
                type="text"
                className="form-control"
                id="Name"
                placeholder="Enter First Name"
                value = {self.state.Update.FirstName}
                onChange={(event)=> self.setState({Update:{...self.state.Update,FirstName:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Name">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="Name"
                placeholder="Enter Last Name"
                value = {self.state.Update.LastName}
                onChange={(event)=> self.setState({Update:{...self.state.Update,LastName:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Name">Email</label>
              <input
                type="text"
                className="form-control"
                id="Email"
                placeholder="Enter First Name"
                value = {self.state.Update.Email}
                onChange={(event)=> self.setState({Update:{...self.state.Update,Email:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Name">Phone</label>
              <input
                type="text"
                className="form-control"
                id="Phone"
                placeholder="Enter Phone Number"
                value = {self.state.Update.Phone}
                onChange={(event)=> self.setState({Update:{...self.state.Update,Phone:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
              <label htmlFor="Name">Address</label>
              <div className="float-right">
                <button type="button" style={{ fontSize : 12 }} className="btn btn-sm btn-success" onClick={() => self.__ToogleMapModal__(2)}><i className="fa fa-dot-circle-o"></i> Select in Map</button>
              </div>
              <input
                type="text"
                className="form-control"
                id="Email"
                placeholder="Enter First Name"
                value = {self.state.Update.Address}
                onChange={(event)=> self.setState({Update:{...self.state.Update,Address:event.target.value} })}
              />
              </div>
              <div className="col-md-6">
              <label htmlFor="Name">Address 2</label>
              <input
                type="text"
                className="form-control"
                id="Name"
                placeholder="Enter Last Name"
                value = {self.state.Update.Address2}
                onChange={(event)=> self.setState({Update:{...self.state.Update,Address2:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-6">
                  <label htmlFor="Name">City</label>
                  <Select
                    name="PurchaseVendorName"
                    placeholder="Type City"
                    value={self.state.Update.CityAbbreviations}
                    options={RenderHelper.RenderMasterAutoComplete(self.props.CityReducer,true)}
                    onChange={(val)=>self.__UpdateHandleCityChanged__(val,self)}
                  />
              </div>
              <div className="col-md-6">
              <label htmlFor="Name">Postal</label>
              <input
                type="text"
                className="form-control"
                id="Name"
                placeholder="Enter Postal"
                value = {self.state.Update.Postal}
                onChange={(event)=> self.setState({Update:{...self.state.Update,Postal:event.target.value} })}
              />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-5">
                <label htmlFor="Name">Tag</label>
                <input
                  type="text"
                  className="form-control"
                  id="Name"
                  placeholder="Enter Last Name"
                  value = {self.state.Update.Tag}
                  onChange={(event)=> self.setState({Update:{...self.state.Update,Tag:event.target.value} })}
                />
              </div>
              <div className="col-md-5">
                <label htmlFor="Name">Role</label>
                <Select
                  name="PurchaseVendorName"
                  placeholder="Type Role"
                  value={self.state.Update.RoleAlias}
                  options={RenderHelper.RenderMasterAutoComplete(self.props.RoleReducer,true)}
                  onChange={(val)=>self.__UpdateHandleRoleChanged__(val,self)}
                />
              </div>
              <div className="col-md-2">
                <div>
                  <label className="spaceR">Is Active</label>
                </div>
                <label className="switch switch-lg switch-text switch-success">
                  <input 
                    onChange={(event)=>self.setState({ Update:{...self.state.Update, Active: event.target.checked} })} 
                    name="cLost" type="checkbox" 
                    className="switch-input" 
                    checked={self.state.Update.Active}
                  />
                  <span className="switch-label" data-on="Yes" data-off="No"></span>
                  <span className="switch-handle"></span>
                </label>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleUpdateModal__}>Cancel</Button>
          <Button color="primary" onClick={()=>self.__Update__(self)}>Save</Button>
        </ModalFooter>
      </Modal>
    )
  },
  ResetPasswordModal:function(self){
    return(
      <Modal isOpen={self.state.Cridential.modal} toggle={self.__ToogleResetPasswordModal__} className={'modal-lg ' + self.props.className}>
        <ModalHeader toggle={self.__ToogleResetPasswordModal__}>{'Reset Password'}</ModalHeader>
        <ModalBody>
        <div className="card-block">
          <div className="form-group">
            <label>Old Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter Old Password"
              value = {self.state.Cridential.OldPassword}
              onChange={(event)=> self.setState({Cridential:{...self.state.Cridential,OldPassword:event.target.value} })}
            />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter New Password"
              value = {self.state.Cridential.NewPassword}
              onChange={(event)=> self.setState({Cridential:{...self.state.Cridential,NewPassword:event.target.value} })}
            />
          </div>
          <div className="form-group">
            <label>Re-enter Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Re-enter New Password"
              value = {self.state.Cridential.ReNewPassword}
              onChange={(event)=> self.setState({Cridential:{...self.state.Cridential, ReNewPassword:event.target.value} })}
            />
          </div>
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={self.__ToogleResetPasswordModal__}>Cancel</Button>
          <Button color="primary" onClick={()=>self.__UpdatePassword__(self)}>Save</Button>{' '}
        </ModalFooter>
      </Modal>
    )
  },
}



// WEBPACK FOOTER //
// ./src/App/user/model/helper/modal.js